import React from 'react';
import { Clock, Users } from 'lucide-react';
import { useCountdown } from '../lib/countdown';
const SEATS_LEFT = 50;
export function UrgencyBanner() {
  const {
    minutes,
    seconds
  } = useCountdown();
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="inline-flex flex-col sm:flex-row items-stretch rounded-2xl overflow-hidden border border-sage-light/40 shadow-sm bg-white mb-4" data-id="element-273">
      <div className="flex items-center px-4 py-2.5 bg-terracotta text-white" data-id="element-274">
        <Clock className="w-4 h-4 mr-2 shrink-0" data-id="element-275" />
        <span className="text-xs font-bold uppercase tracking-wider mr-3 flash-white" data-id="element-276">
          Oferta termina en
        </span>
        <div className="flex items-center font-mono font-bold text-lg tabular-nums flash-white" data-id="element-277">
          <span data-id="element-278">{pad(minutes)}</span>
          <span className="mx-1" data-id="element-279">:</span>
          <span data-id="element-280">{pad(seconds)}</span>
        </div>
      </div>
      <div className="flex items-center px-4 py-2.5 bg-cream-light" data-id="element-281">
        <Users className="w-4 h-4 mr-2 text-sage-dark shrink-0" data-id="element-282" />
        <span className="text-sm font-medium text-gray-800" data-id="element-283">
          Solo{' '}
          <span className="font-bold flash-terracotta" data-id="element-284">{SEATS_LEFT} cupos</span>{' '}
          disponibles
        </span>
      </div>
    </div>;
}